import type { Pixel } from "@pdfking/math"
import { PX } from "@pdfking/quantity"

// What a notebook's page is ruled with, in points, as the shop's notepad
// templates draw it: exact for offset, where anything thinner may not print

/** A line's stroke: a lined page's, a squared one's, a millimetre paper's
 * every fifth, and every rule written on */
export const LINE_STROKE = PX(0.5 as Pixel)
/** A millimetre paper's other lines, and a calendar grid's inside it */
export const MILLIMETER_STROKE = PX(0.3 as Pixel)
/** A dotted page's dot, across */
export const DOT = PX(1.5 as Pixel)
/** A dotted line's dot, across, and its pitch along the line, as the agendas'
 * notes have them */
export const LINE_DOT = PX(1 as Pixel)
export const LINE_DOT_PITCH = PX(3 as Pixel)
